
                    import { isAvailableLanguageTag, setLanguageTag, sourceLanguageTag } from "virtual:paraglide-astro:runtime";
					const htmlLang = document.documentElement.lang;
					const language = isAvailableLanguageTag(htmlLang) ? htmlLang : sourceLanguageTag;
					setLanguageTag(language);
                    